// extracted by mini-css-extract-plugin
module.exports = {"calendarBtn":"DropdownActions_calendarBtn__LiG2G","acceptanceBtn":"DropdownActions_acceptanceBtn__3FgK_"};